/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { FETCH_FARTHEST_AVAILABILITY } from './tourAvailabilityActions';

export const FETCH_FACILITY_AVAILABILITY = 'FETCH_FACILITY_AVAILABILITY';
export const FETCH_FACILITY_AVAILABILITY_SUCCESS = 'FETCH_FACILITY_AVAILABILITY_SUCCESS';
export const FETCH_FACILITY_AVAILABILITY_ERROR = 'FETCH_FACILITY_AVAILABILITY_ERROR';
export const SET_FETCH_FACILITY_AVAILABILITY_STATUS =
    'SET_FETCH_FACILITY_AVAILABILITY_STATUS';
export const RESET_FACILITY_AVAILABILITY = 'RESET_FACILITY_AVAILABILITY';

// If the function call doesn't specify the numberOfMonths to fetch, then we fall back to this.
// Goal is to fetch 1 more month than is displayed so there is no jank
// when the user clicks the next month button
export const MONTHS_TO_FETCH = 1;

export function fetchFacilityAvailabilitySuccess(data) {
    return {
        type: FETCH_FACILITY_AVAILABILITY_SUCCESS,
        payload: data,
    };
}

export function fetchFacilityAvailabilityError(error) {
    return {
        type: FETCH_FACILITY_AVAILABILITY_ERROR,
        payload: error,
    };
}

export function setFetchFacilityAvailabilityStatus(status) {
    return {
        type: SET_FETCH_FACILITY_AVAILABILITY_STATUS,
        payload: status,
    };
}

export function fetchFacilityAvailability({
    facilityId,
    date,
    numberOfMonths = MONTHS_TO_FETCH,
}) {
    return (dispatch) => {
        dispatch({
            type: FETCH_FACILITY_AVAILABILITY,
            payload: { facilityId, date, numberOfMonths },
        });
        dispatch({
            type: FETCH_FARTHEST_AVAILABILITY,
            payload: { facilityId },
        });
    };
}

export function resetFacilityAvailability() {
    return {
        type: RESET_FACILITY_AVAILABILITY,
    };
}
